/** ****************************************************************************
		███╗   ██╗███████╗██████╗  █████╗  ██████╗
		████╗  ██║██╔════╝██╔══██╗██╔══██╗██╔═══██╗
		██╔██╗ ██║█████╗  ██║  ██║███████║██║   ██║
		██║╚██╗██║██╔══╝  ██║  ██║██╔══██║██║   ██║
		██║ ╚████║███████╗██████╔╝██║  ██║╚██████╔╝
		╚═╝  ╚═══╝╚══════╝╚═════╝ ╚═╝  ╚═╝ ╚═════╝

@description template des pages.

@author Victor Audetat <audetat.v@gmail.com>

@copyright © 2020  NEDAO Association (info@nedao.ch)
@see {@link https://nedao.ch}

@license
	This program is free software: you can redistribute it and/or modify
	it under the terms of the GNU Affero General Public License as published
	by the Free Software Foundation, either version 3 of the License, or
	(at your option) any later version.

	This program is distributed in the hope that it will be useful,
	but WITHOUT ANY WARRANTY; without even the implied warranty of
	MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	GNU Affero General Public License for more details.

	You should have received a copy of the GNU Affero General Public License
	along with this program.  If not, see <https://www.gnu.org/licenses/>.
*******************************************************************************/

import * as React from 'react';
import Footer from '../footer/footer';
import Header from '../header/header';
import Ruban from '../ruban/ruban';
import Seo from '../seo/seo';
import './../../styles/normalize.scss';
import './layout.scss';
import './../../styles/main.scss';

const Layout = ({ title, children, description, lang, social}) => {
	console.log(social);
	return (
		<div className="global-wrapper">
			<Seo
				title={title}
				description={description}
				lang={lang}
				social={
					{
						type: social?.type,
						image: social?.image,
						slug: social?.slug
					}
				}
			/>
			<Ruban/>
			<Header />
			<main>
				{children}
			</main>
			<Footer />
		</div>
	);
};

export default Layout;
